import styled from "styled-components";
import colorPalette from "@streeteasy/design-system/deprecated/colors";
import Title from "@streeteasy/design-system/deprecated/Title";

import ContactGroup from "src/shared/contact-boxes/components/ContactGroup";

const ContactsListText = styled(Title).attrs({ type: "secondarySmCaps" })`
  color: ${colorPalette.koalaGrey};
`;

const ContactsList = styled(ContactGroup)`
  margin-top: 15px;
`;

const ContactsListStyle = styled.div`
  border-bottom: 0;
  border-top: 1px solid ${colorPalette.rabbitGrey};
  display: block;
  margin-bottom: 15px;
  margin-top: 25px;
  padding-bottom: 0;
  padding-top: 26px;
`;

ContactsListText.displayName = "ContactsListText";
ContactsListStyle.displayName = "ContactsListStyle";

export { ContactsListStyle, ContactsListText, ContactsList };
